<template>
  <div class="login_box" v-if="code_show">
    <div class="login_ct">
      <div class="login_mark"></div>
      <div class="login_option">
        <div class="linear">
          <div class="linear_lt"></div>
          <div class="code_title">{{ codeTitle }}</div>
          <div class="linear_rt">
            <img @click="handelClosePop" src="@/assets/image/reserve_cancel_ic.png" alt="">
          </div>
        </div>
        <div class="nav-tips" v-if="showNavTips">{{ navTips }}</div>
        <div class="main">
          <div class="code_top">
            <div class="code_top_lt" ref="qrContainer"></div>
            <div class="code_top_rt">
              <div>
                <img class="code_top_logo" src="@/assets/image/50_logo.png" alt="">
                <h1>爆款手游，独家福利！</h1>
              </div>
              <div>
                <img class="code_top_scan" src="@/assets/image/scan.png" alt="">
                <h6>用微信/浏览器扫码下载APP</h6>
              </div>
            </div>
          </div>
        </div>
        <p class="tips" v-if="showTips">
          {{ tipsPrefix }}<span>{{ tipsHighlight }}</span>{{ tipsSuffix }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import regMethods from '@/mixs/regMethods'
import { postData } from '@/api/api.js'
import { mapMutations, mapState } from 'vuex'
import Bus from '@/util/Bus'
import QRCode from 'qrcodejs2'

export default {
  name: 'codePopup',
  props: {
    code_show: {
      type: Boolean,
      required: true,
      default: true,
    },
    code_title: {
      type: String,
      default: '请用微信/浏览器扫码进行体验',
    },
    title: {
      type: String,
      default: '',
    },
    showNavTips: {
      type: Boolean,
      default: false,
    },
    navTips: {
      type: String,
      default: '(请前往移动端进行实名认证)',
    },
    showTips: {
      type: Boolean,
      default: true,
    },
    tipsPrefix: {
      type: String,
      default: '扫码打开',
    },
    tipsHighlight: {
      type: String,
      default: '50手游APP',
    },
    tipsSuffix: {
      type: String,
      default: '进行游玩',
    }
  },
  mixins: [regMethods],
  data() {
    return {
      information: [],
      box_link: null,
    }
  },
  computed: {
    ...mapState(['uid', 'requestParams', 'platform']),
    codeTitle() {
      return this.title || this.code_title
    },
  },
  watch: {
    code_show(newVal) {
      if (newVal) {
        this.boxLink()
      }
    }
  },
  methods: {
    ...mapMutations(['handelUid', 'clearLoggedInUser', 'handelSdkGid']),

    // 关闭弹窗
    handelClosePop() {
      this.$emit('update:code_show', false)
      this.$emit('close')
      Bus.$emit('codePopopShow', false)
    },
    async boxLink() {
      try {
        const res = await postData('/box/box-link')
        if (res?.code === 0) {
          this.box_link = res.data.box_link
          this.generateQRCode(res.data.landing_url)
        }
      } catch (err) {
        console.log(err)
      }
    },
    generateQRCode(box_link) {
      if (!this.$refs.qrContainer) return
      this.$refs.qrContainer.innerHTML = ''
      new QRCode(this.$refs.qrContainer, {
        text: box_link,
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  },
}
</script>

<style scoped lang="less">
.login_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
}

.login_ct {
  position: relative;
  width: 100%;
  height: 100%;

  .login_mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  .login_option {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 380px;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 0 0 40px 0;
    z-index: 2;

    .linear {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 25px 26px 10px 16px;
      box-sizing: border-box;
      border-radius: 20px 20px 0 0;
      background: linear-gradient(to bottom, #FFE8E9, #FFFFFF);

      .linear_lt {
        width: 16px;
        height: 16px;
      }

      .code_title {
        font-size: 20px;
        font-weight: 700;
      }

      .linear_rt {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .nav-tips {
      margin-top: 4px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
    }

    .main {
      max-height: 384px;
      min-height: 100px;
      overflow-y: auto;
      font-size: 16px;
      padding: 10px 25px;
      box-sizing: border-box;

      .code_top {
        display: flex;
        justify-content: center;
        margin-top: 20px;

        .code_top_lt {
          width: 100px;
          height: 100px;
          border: 2px solid #ffffff;
        }

        .code_top_rt {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 15px;

          h1 {
            font-size: 16px;
          }

          h6 {
            font-size: 12px;
            text-align: left;
          }

          .code_top_logo {
            height: 28px;
          }

          .code_top_scan {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }

  .tips {
    margin-top: 20px;

    span {
      color: #FF3838;
    }
  }
}
</style>
